import { AUTH_TYPE_SERVER } from '@ww/login-ui-components/lib/hooks/useAutoRedirect';

export const PREV_URL_KEY = 'prevUrl';
export const APP_NAME_KEY = 'appName';
export const AUTH_TYPE_KEY = 'authType';

export const AppName = {
  PLAYGROUND: 'playground',
  ABU_TAGGING: 'abu-tagging'
} as const;

export type AppNameValue = (typeof AppName)[keyof typeof AppName];

export function isServerAuthType(searchParams: URLSearchParams): boolean {
  return searchParams.get(AUTH_TYPE_KEY) === AUTH_TYPE_SERVER;
}

export function getAppName(searchParams: URLSearchParams): AppNameValue | null {
  const appName = searchParams.get(APP_NAME_KEY)?.toLowerCase();

  return shouldAllowAppLogin(appName) ? appName : null;
}

function shouldAllowAppLogin(appName?: string): appName is AppNameValue {
  return Object.values(AppName).some((appWeServe) => appWeServe === appName);
}
